import Utilities from "../utils/Utilities";
import { VscInfo } from "react-icons/vsc";
import { Tooltip } from "react-tooltip";
import styles from "./SelectedServices.module.scss";
import useMobile from "../../hooks/useMobile";
import usePreferencesStore from "../../store/preferencesStore";
import { useState } from "react";

function SelectedServices(props) {
  const isMobile = useMobile();
  const { preferences } = usePreferencesStore();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={styles["services-container"]}>
      {props.data &&
        props.data.map((item, index) => {
          const service = Utilities.getServiceById(
            props.services,
            item.id_service
          );
          const employee = Utilities.getEmployeeById(
            props.employees,
            item.idStaffItem ? item.idStaffItem : ""
          );
          if (index < 2 || isExpanded) {
            return (
              <div
                className={styles["service-container"]}
                key={index}
                islast={index === props.data.length - 1 ? "yes" : "no"}
                isfirst={index === 0 ? "yes" : "no"}
              >
                <div className={styles["service-row"]}>
                  {item.includedServices &&
                    item.includedServices.length > 0 && <></>}

                  <div className={styles["service-col1"]}>
                    <div className={styles["service-title"]}>
                      {item && item.name}
                      {item.info && (
                        <>
                          <div
                            data-tooltip-id="info-icon-tooltip"
                            data-tooltip-content={item.info}
                            data-tooltip-place="top"
                          >
                            <VscInfo
                              size="20"
                              className={styles["info-icon"]}
                            />
                          </div>
                          <Tooltip
                            id="info-icon-tooltip"
                            className={styles["info-icon-text-panel"]}
                            place="top"
                            style={{
                              backgroundColor: "white",
                              color: "#222",
                              width: 300,
                            }}
                          />
                        </>
                      )}
                    </div>
                    <div className={styles["service-duration"]}>
                      {item && service?.worker_duration} min
                    </div>
                  </div>
                  {isMobile ? (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      {item && employee && (
                        <div
                          className={styles["service-col2"]}
                          style={
                            isMobile
                              ? { minWidth: "130px" }
                              : { minWidth: "224px" }
                          }
                        >
                          {employee.iconJsx}
                          <span>{employee.employee_name}</span>
                        </div>
                      )}
                      <div className={styles["service-col3"]}>
                        <div className={styles["service-price"]}>
                          {preferences.mostra_prezzi_listino && (
                            <>
                              {preferences.prefix}{" "}
                              {Utilities.getSelectedServicePrice(
                                item,
                                props.services
                              )
                                .toFixed(2)
                                .toString()
                                .replace(".", ",")}{" "}
                              €
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      {item && employee && (
                        <div
                          className={styles["service-col2"]}
                          style={
                            isMobile
                              ? { minWidth: "130px" }
                              : { minWidth: "224px" }
                          }
                        >
                          {employee.iconJsx}
                          <span>{employee.employee_name}</span>
                        </div>
                      )}
                      <div className={styles["service-col3"]}>
                        <div className={styles["service-price"]}>
                          {preferences.mostra_prezzi_listino && (
                            <>
                              {preferences.prefix}{" "}
                              {Utilities.getSelectedServicePrice(
                                item,
                                props.services
                              )
                                .toFixed(2)
                                .toString()
                                .replace(".", ",")}{" "}
                              €
                            </>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            );
          } else {
            return null;
          }
        })}
      {props.moreThan2Services && props.data.length > 2 && (
        <div className={styles["show-more-container"]} onClick={toggleExpand}>
          <span className={styles["show-more-text"]}>
            {isExpanded
              ? "- Nascondi servizi"
              : `+ Altri ${props.data.length - 2} servizi`}
          </span>
        </div>
      )}
    </div>
  );
}

export default SelectedServices;
